const t=t=>`attachment; filename="${t}"`;export{t as getContentDispositionHeaderFilename};
